// place here categories that you want to track. We want to track just a
// small subset of categories at a given time.
const ALLOWED_CATEGORIES_TO_TRACK = ["ai"] as string[];

export const trackEvent = (
  category: string,
  action: string,
  label?: string,
  value?: number,
) => {
  try {
    // prettier-ignore
    if (
      typeof window === "undefined"
    ) {
      return;
    }

    if (!ALLOWED_CATEGORIES_TO_TRACK.includes(category)) {
      return;
    }
    console.info("trackEvent", { category, action, label, value });
  } catch (error) {
    console.error("error during analytics", error);
  }
};
